// Loaded from layout/theme.liquid. Restored from the live theme — this file was missing from the repo.

// Adds body.scrolled once the page is scrolled, used by custom-styles.css for the header border.
const mBody = document.getElementsByTagName('body')[0];

function scrollHeightCheck() {
  window.scrollY >= 100 ? mBody.classList.add('scrolled') : mBody.classList.remove('scrolled');
}

window.addEventListener('scroll', scrollHeightCheck, { passive: true });
scrollHeightCheck();

// Don't autoplay videos for visitors who prefer reduced motion.
const videos = document.querySelectorAll('video[autoplay]');
const motionQuery = matchMedia('(prefers-reduced-motion: reduce)');

function handleReduceMotionChanged() {
  if (!motionQuery.matches) return;
  videos.forEach((video) => video.removeAttribute('autoplay'));
}

motionQuery.addEventListener('change', handleReduceMotionChanged);
handleReduceMotionChanged();
